export default __webpack_public_path__ + "static/media/icon_collection.31c39112.svg";